import { useState, useEffect } from 'react';
import { fetchDownloads } from './downloads';
import { usePageTitle } from './hooks/usePageTitle';

import DownloadList from './components/DownloadList';

import type { DownloadListItemProps } from './components/DownloadListItem';

import {LoadingAnimatedPage } from './components/Loading';

interface DownloadData {
  num_downloads: number;
  downloads: Array<{
    filename: string;
    url: string;
    uploaded_at: string;
  }>;
  userSoftware: Array<{
    name: string;
    activated?: boolean;
    endsAt?: string;
    startedAt?: string;
    webIcon?: string;
    description?: string;
    displayName: string;
    currentVersion?: string;
    uploadedAt?: any;
  }>;
}

export default function Downloads() {
  const [downloads, setDownloads] = useState<DownloadData | null>(null);
  const [loading, setLoading] = useState(true);

  usePageTitle('Downloads');

  useEffect(() => {
    fetchDownloads()
      .then(setDownloads)
      .catch(console.error)
      .finally(() => setLoading(false));

  }, []);

  if (loading) return (
  <div>
    <LoadingAnimatedPage />
  </div>
  );

  function timestampToDate(ts: any): Date | null {
    if (ts && typeof ts === 'object' && '_seconds' in ts) {
      return new Date(ts._seconds * 1000 + (ts._nanoseconds || 0) / 1000000);
    }
    if (ts && typeof ts.toDate === 'function') {
      return ts.toDate();
    }
    return null;
  }

  function formatUserSoftware(
    userSoftware: DownloadData['userSoftware']
  ): DownloadListItemProps[] {
    return userSoftware.map((s) => {
      const startedDate = timestampToDate(s.startedAt);
      const endsDate = timestampToDate(s.endsAt);
      const uploadedAt = timestampToDate(s.uploadedAt);
      return {
        filename: s.name,
        description: '',
        linkURL: `api/downloads/${s.name}`,
        displayName: s.displayName,
        webIcon: s.webIcon,
        currentVersion: s.currentVersion,
        startDate: startedDate ? startedDate.toLocaleDateString() : undefined,
        endDate: endsDate ? endsDate.toLocaleDateString() : undefined,
        history: Array.isArray((s as any).history) ? (s as any).history : [],
        uploadedAt: s.uploadedAt ? uploadedAt?.toLocaleDateString() : undefined
      };
    });
  }

  const downloadSoftwareItems = downloads
    ? formatUserSoftware(downloads.userSoftware)
    : [];

  return (
    <div
      id="ts-profile-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-profile-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 mb-4 border-b border-light-border">
          Downloads
        </div>
        <DownloadList items={downloadSoftwareItems} />
      </div>
    </div>
  );
}
